import { lazy } from "react";

const ItemPage = lazy(() => import("./items/ItemPage"));
const ReviewHome = lazy(() => import("./ReviewHome"));

const reviewItemRoutes = [
  {
    // Specific review view - separate from reviews filter routes
    path: "review/:reviewId",
    children: [
      {
        path: "",
        element: ReviewHome,
      },
      {
        path: ":reviewItemId",
        element: ItemPage,
      },
    ],
  },
];
export default reviewItemRoutes;
